<template>
  <div class="statistics_inner_wrap d-flex flex-wrap justify-center">
    <search-form title="치아별" @reset="reset" @search="search"></search-form>
    <v-card class="chart_card teeth_status_img_wrap mt-5" width="1360">
      <div class="chart_header">
        <div class="d-flex align-center">
          <i class="icon status_list"></i>
          치아별 구강상태
        </div>
      </div>
      <no-data-box v-if="data.takeCount === 0" :height="500"></no-data-box>
      <template v-else>
        <div class="status_summary_wrap d-flex align-center">
          <div class="status_text">
            <div>
              <span v-if="selectedDate.startDate">{{ $convertDateFormat('YYYYMMDDKR', selectedDate.startDate) }}부터</span>
              <span v-if="selectedDate.endDate">{{ $convertDateFormat('YYYYMMDDKR', selectedDate.endDate) }}까지</span>
              구강 촬영한 고양, 파주 지역 장병수는 {{ `${data.soldierCount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}명입니다.
            </div>
            <span>전체 구강 촬영횟수</span>
            <span>{{ `${data.takeCount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} 회 (장병당 평균 {{ data.takeAverage }}회 촬영)</span>
          </div>
        </div>
        <div class="chart_wrap d-flex">
          <div v-for="(item, index) in teethStatus" :key="index" class="chart_box" :class="{ margin: index !== 0 }">
            <div class="teeth_box">
              <teeth-box :data="item.data" parent="statistics" :label-text="item.labelText"></teeth-box>
            </div>
            <div>{{ item.chartLabel }}</div>
          </div>
        </div>
      </template>
    </v-card>
  </div>
</template>

<script>
import SearchForm from '@/components/statistics/SearchForm';
import TeethBox from '@/components/common/TeethBox';
import NoDataBox from '@/components/common/NoDataBox';
import Api from '@/apis/api';
import { mapState } from 'vuex';
export default {
  name: 'OralStatistics',
  components: {
    SearchForm,
    TeethBox,
    NoDataBox,
  },
  data: () => ({
    data: {
      takeCount: 0,
      soldierCount: 0,
      takeAverage: 0,
      upRight: {},
      downRight: {},
      upLeft: {},
      downLeft: {},
    },
    selectedDate: {
      startDate: '',
      endDate: '',
    },
    teethStatus: [],
  }),
  computed: {
    ...mapState('commonValue', ['healthStatus']),
  },
  watch: {
    '$route.query'() {
      this.getListStatisticsOral();
    },
  },
  created() {
    this.getListStatisticsOral();
  },
  methods: {
    getListStatisticsOral() {
      this.$root.spinner.set(true);
      Object.assign(this.selectedDate, this.$route.query);
      let form = {};
      for (const i in this.$route.query) {
        if (i !== 'active') form[i] = this.$route.query[i];
      }
      Api.getStatisticsOral(form).then(res => {
        if (res && res.data.rt === 200) {
          for (const key in this.data) {
            this.data[key] = res.data[key];
          }
          this.setTeethStatus();
          this.$root.spinner.set(false);
        } else {
          this.$root.alert.show({
            content: `알 수 없는 오류가 발생했습니다. 관리자에게 문의해주세요. 오류 코드 : ${res.data.rt}`,
          });
        }
      });
    },
    setTeethStatus() {
      this.teethStatus.push(
        {
          chartLabel: '치아별 전체 장병 구강상태',
          data: this.data,
          labelText: true,
        },
        {
          chartLabel: '왼쪽 위',
          data: {
            upRight: this.data.upRight,
          },
        },
        {
          chartLabel: '오른쪽 위',
          data: {
            upLeft: this.data.upLeft,
          },
        },
        {
          chartLabel: '왼쪽 아래',
          data: {
            downRight: this.data.downRight,
          },
        },
        {
          chartLabel: '오른쪽 아래',
          data: {
            downLeft: this.data.downLeft,
          },
        },
      );
    },
    reset() {
      if (JSON.stringify(this.$route.query) !== JSON.stringify({})) {
        this.$router.push({ query: null });
      }
    },
    search(data) {
      let query = {};
      for (const i in data) {
        if (data[i]) {
          query[i] = data[i];
        } else {
          delete query[i];
        }
      }
      if (JSON.stringify(query) !== JSON.stringify(this.$route.query)) {
        this.$router.push({ query: query });
      }
    },
  },
};
</script>

<style scoped></style>
